import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { UserStore } from '@sharedcommon/store/user.store';

@Injectable()
export class StoredUserGuard implements CanActivate {

  constructor(private readonly userStore: UserStore, private readonly router: Router) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const user = this.userStore.getUserEntity();
    /* Check if the stored user has all necessary information */
    if (user?.activity && user.operatingMode) {
      return true;
    }
    /* If not all necessary information then redirect to the entity selection page */
    console.warn("[StoredUserGuard] Wrong stored user information");
    this.router.navigateByUrl("entity");
    return false;
  }
}
